const getDeviceInfo = () => {

    const windowDeviceBootstrap = window?.deviceBootstrap;

    if(typeof windowDeviceBootstrap !== 'function') {

        return undefined;

    }

    const currentDevice = windowDeviceBootstrap() || {};

    return {
        userAgent: currentDevice.userAgent,
        formFactor: currentDevice.formFactor ?? 'desktop',
        details: currentDevice.is,
        browser: currentDevice.browser,
        browserVersion: currentDevice.browserVersion,
        platform: typeof currentDevice.getPlatform === 'function' ? currentDevice.getPlatform() : undefined,
    };

};

export default getDeviceInfo;
